/** Shared shape for dirty-close / preserve-close confirm copy. */
export interface CloseConfirmCopy {
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  confirmVariant: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'purple' | 'ghost'
  /** When set, overrides BaseConfirmDialog auto layout (danger would otherwise use centered + icon). */
  dialogLayout?: 'default' | 'centered'
}

/** Copy for dirty close confirmation (Type A — state is discarded on close). */
export const CLOSE_CONFIRM_DISCARD: CloseConfirmCopy = {
  title: 'Close without saving?',
  message: 'Your unsaved changes will be lost.',
  confirmLabel: 'Close',
  cancelLabel: 'Cancel',
  confirmVariant: 'danger',
  dialogLayout: 'default'
}

/** Copy for dirty close when draft is preserved (Type B — e.g. bug report localStorage). */
export const CLOSE_CONFIRM_PRESERVE: CloseConfirmCopy = {
  title: 'Close this window?',
  message: 'Are you sure you want to close this window?',
  confirmLabel: 'Close',
  cancelLabel: 'Cancel',
  confirmVariant: 'primary'
}
